const initCompare = () => {



    $('.new-compare').click(e => {
        var compareItems = $('.compare-head-item');
        if ($(window).innerWidth() < 992 && compareItems.length > 1) {
            alert("حداکثر 2 عدد کالا برای مقایسه می‌توانید انتخاب کنید.")
        } else {
            $('.compare-modal').css('display', 'flex');
            $('.modal-overlay').show();
            $('#site-container').addClass('blur');
            $('body').css('overflow', 'hidden')
        }
    })
    $('.modal-overlay').click(e => {
        $('.compare-modal').css('display', 'none');
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');
    })

};

export {
    initCompare
};
